<template>
    <div class="multify-uploader-wraper">
        <ButtonGroup>
            <Button icon="md-cloud-upload" type="primary" @click="upload">{{uploadTitle}}</Button>
            <Button icon="md-folder-open" type="info" @click="showPanel">显示</Button>
        </ButtonGroup>
        <div class="file-wrapper">
            <div class="paas-upload-list" v-for="item in fileList" :key="`file${item.id}`" >
                <div class="paas-upload-show-file" v-if="format(item.name) === 'ios-image'">
                    <img :src="item.thumbnailUrl?item.thumbnailUrl:item.originalUrl" class="show-upload-file">
                </div>
                <div class="paas-upload-show-file" v-else-if="format(item.name) === 'md-document'">
                    <img src="../image/doc.png" class="show-upload-file"/>
                </div>
                <div class="paas-upload-show-file" v-else-if="format(item.name) === 'ios-document'">
                    <img src="../image/pdf.png" class="show-upload-file"/>
                </div>
                <div class="paas-upload-show-file" v-else-if="format(item.name) === 'ios-stats'">
                    <img src="../image/xls.png" class="show-upload-file"/>
                </div>
                <div class="paas-upload-show-file" v-else-if="format(item.name) === 'ios-videocam'">
                    <img src="../image/ppt.png" class="show-upload-file"/>
                </div>
                <div class="paas-upload-show-file" v-else-if="format(item.name) === 'ios-film' || format(item.name) === 'ios-musical-notes'">
                    <video :src="item.originalUrl" controls="controls" class="show-upload-file"></video>
                    <!--<video-player  :options="setOptions(item)" class="show-upload-file"></video-player>-->
               </div>
               <div class="paas-upload-show-file" v-else>
                   <Icon :type="format(item.name)"></Icon>
               </div>
               <div class="file-name" :title="item.name">{{item.filename}}</div>
               <div class="paas-upload-list-cover">
                   <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                   <Icon type="ios-trash-outline" @click.native="deleteUploadFile(item.id)"></Icon>
               </div>
           </div>
       </div>
       <div id="global-uploader">
           <!-- 上传 -->
            <uploader
                    ref="uploader"
                    :options="options"
                    :autoStart="true"
                    :file-status-text="statusText"
                    @file-added="onFileAdded"
                    @file-success="onFileSuccess"
                    @file-progress="onFileProgress"
                    @file-error="onFileError"
                    class="uploader-app">
                <uploader-unsupport></uploader-unsupport>

                <uploader-btn id="global-uploader-btn" :attrs="attrs" :single="single" ref="uploadBtn">选择文件</uploader-btn>

                <uploader-list v-show="panelShow">
                    <div class="file-panel" slot-scope="props" :class="{'collapse': collapse}">
                        <div class="file-title">
                            <h4>文件列表</h4>
                            <div class="operate">
                                <Button @click="fileListShow"
                                        type="text"
                                        :title="collapse ? '展开':'折叠' "
                                        :icon="collapse ? 'md-expand': 'ios-arrow-down'">
                                </Button>
                                <Button @click="close" type="text" title="关闭" icon="md-close">
                                </Button>
                            </div>
                        </div>

                        <ul class="file-list">
                            <li v-for="file in props.fileList" :key="file.id">
                                <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
                            </li>
                            <div class="no-file" v-if="!props.fileList.length"><i class="iconfont icon-empty-file"></i> 暂无待上传文件</div>
                        </ul>
                    </div>
                </uploader-list>
            </uploader>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import { deleteFileById } from "@api/admin.js";

    export default {
        name: "mult-uploader",
        props: {
            businessId:{
                type: String,
                default: ""
            },
            tempId:{
                type: String,
                default: ""
            },
            businessType:{
                type: String,
                default: "",
            },
            businessProperty:{
                type: String,
                default: ""
            },
            basedictStorage:{
                type: String,
                default: "localServer"
            }, //上传后存储的位置
            single:{
                type:Boolean,
                default:false
            },  //是否单选
            uploadTitle:{
                type: String,
                default: "上传"
            },  //更改上传按钮的内容
            fileList:{
                type:Array,
                default:[]
            },
            thumbWidth:{
                type: String,
                default: ""
            }, //只适用于图片，是否有缩略图
            maxWidth:{
                type: String,
                default: ""
            }, //只适用于图片，是否对上传的图片处理
            maxHeight:{
                type: String,
                default: ""
            }, //只适用于图片，是否对上传的图片处理
            uploadType:{
                type: String,
                default: ""
            }
        },
        data(){
            return {
                options: {
                    target: this.$store.state.sysApi+'/sys/file/uploadFileSlice',
                    testChunks: false,   //是否开启服务器分片校验
                    simultaneousUploads: 2, //并发上传数，默认3。
                    chunkSize: 10 * 1024 * 1024, //分块时按照该值来分。最后一个上传块的大小是可能是大于等于1倍的这个值但是小于两倍的这个值大小，默认 110241024。
                    forceChunkSize: false, //是否强制所有的块都是小于等于 chunkSize 的值
                    singleFile: this.single,
                    fileParameterName: 'file', //上传文件时文件的参数名，默认 file。
                    progressCallbacksInterval: 500,
                    speedSmoothingFactor: 0.1,
                    query: {
                        "businessType": this.businessType,
                        "businessId": this.businessId,
                        "tempId": this.tempId,
                        "businessProperty": this.businessProperty,
                        "basedictStorage": this.basedictStorage,
                    },//其他额外的参数，这个可以是一个对象或者是一个函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk 以及是否是测试模式，默认为 {}。
                    headers: {},//额外的一些请求头，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk 以及是否是测试模式，默认 {}。
                    withCredentials: false,//标准的 CORS 请求是不会带上 cookie 的，如果想要带的话需要设置 withCredentials 为 true，默认 false。
                    preprocess: null, //可选的函数，每个块在测试以及上传前会被调用，参数就是当前上传块实例 Uploader.Chunk，注意在这个函数中你需要调用当前上传块实例的 preprocessFinished 方法，默认 null。
                    method: 'multipart',//当上传的时候所使用的是方式,可选 multipart、octet，默认 multipart
                    uploadMethod: 'POST', //真正上传的时候使用的 HTTP 方法，可以是字符串或者函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk，默认 POST。
                    prioritizeFirstAndLastChunk: false, //对于文件而言是否高优先级发送第一个和最后一个块。一般用来发送到服务端，然后判断是否是合法文件；例如图片或者视频的 meta 数据一般放在文件第一部分，这样可以根据第一个块就能知道是否支持；默认 false。
                    allowDuplicateUploads: false,// 是否允许重复上传，如果说一个文件以及上传过了是否还允许再次上传。默认的话如果已经上传了，除非你移除了否则是不会再次重新上传的，所以也就是默认值为 false。
                    generateUniqueIdentifier: null,
                    maxChunkRetries: 0,
                    chunkRetryInterval: null,
                    permanentErrors: [404, 415, 500, 501],
                    successStatuses: [200, 201, 202],
                    onDropStopPropagation: false,
                    initFileFn: null,
                    checkChunkUploadedByResponse: null,

                    /**
                     * 格式化剩余时间。以下代码把英文时间转成中文：
                     * @param timeRemaining
                     * @param parsedTimeRemaining
                     * @returns {*}
                     */
                    parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
                        return parsedTimeRemaining
                            .replace(/\syears?/, '年')
                            .replace(/\days?/, '天')
                            .replace(/\shours?/, '小时')
                            .replace(/\sminutes?/, '分钟')
                            .replace(/\sseconds?/, '秒')
                    }
                },
                attrs: {
                    accept: this.uploadType==="video"?['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv','mp3', 'wav', 'wma', 'ogg', 'aac', 'flac']:"image/*",
                },
                statusText: {
                    success: '成功了',
                    error: '出错了',
                    uploading: '上传中',
                    paused: '暂停中',
                    waiting: '等待中'
                },
                panelShow: false,   //选择文件后，展示上传panel
                collapse: true,
            }
        },
        computed: {
            //Uploader实例
            uploader() {
                return this.$refs.uploader.uploader;
            }
        },
        created(){

        },
        methods:{
            setOptions(item){
                return {
                    sources: [{
                        type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: item.originalUrl, // url地址
                    }],
                    poster: "",
                }
            },
            /**
             * 点击上传按钮
             */
            upload(){
                $("#global-uploader-btn").click();
            },
            showPanel(){
                this.panelShow = !this.panelShow;
            },
            /**
             *  这个事件一般用作文件校验，如果说返回了 false，那么这个文件就会被忽略，不会添加到文件上传列表中。
             * @param file
             */
            onFileAdded(file) {
                this.panelShow = true;
                //console.log(file);
            },
            /**
             * 一个文件在上传中，文件上传的过程中会频繁调用该函数
             * @param rootFile
             * @param file
             * @param chunk
             */
            onFileProgress(rootFile, file, chunk) {
                //console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            },
            /**
             * 所有分片上传完成的回调，需要注意的是，由于异步上传，每一次分片上传不会等上一次响应回来才发送，
             * 因此该上传成功的回调时，返回的分片响应可能不是最后一片，因此后续会发送合并请求告诉后台进行合并文件
             * 第一个参数 rootFile 就是成功上传的文件所属的根 Uploader.File 对象，它应该包含或者等于成功上传文件；
             * 第二个参数 file 就是当前成功的 Uploader.File 对象本身；
             * 第三个参数就是 message 就是服务端响应内容，永远都是字符串；
             * 第四个参数 chunk 就是 Uploader.Chunk 实例，它就是该文件的最后一个块实例，如果你想得到请求响应码的话，chunk.xhr.status 就是
             * @param rootFile
             * @param file
             * @param response
             * @param chunk
             */
            onFileSuccess(rootFile, file, response, chunk) {
                let fileJsonObj = $.parseJSON(response);
                let fileData = fileJsonObj.data.data;
                this.fileList.push(fileData);
                this.$emit('update:fileList', this.fileList);
            },
            /**
             * 一个根文件（文件夹）成功上传完成。
             */
            fileComplete() {
                //console.log(this.fileList);
            },
            /**
             * 文件上传出错的回调
             * @param rootFile
             * @param file
             * @param response
             * @param chunk
             */
            onFileError(rootFile, file, response, chunk) {
                this.$Message({
                    message: response,
                    type: 'error'
                })
            },
            /**
             * 关闭panel
             */
            close() {
                this.panelShow = false;
            },
            fileListShow() {
                let $list = $('#global-uploader .file-list');

                if ($list.is(':visible')) {
                    $list.slideUp();
                    this.collapse = true;
                } else {
                    $list.slideDown();
                    this.collapse = false;
                }
            },
            format (fileName) {
                let type = 'ios-image';
                if(fileName && fileName !== '' && fileName != null && fileName !== 'null' && typeof fileName !== "undefined") {
                    const format = fileName.split('.').pop().toLocaleLowerCase() || '';
                    if (['gif','jpg','jpeg','png','bmp','webp'].indexOf(format) > -1) {
                        type = 'ios-image';
                    }
                    else if (['mp4','m3u8','rmvb','avi','swf','3gp','mkv','flv'].indexOf(format) > -1) {
                        type = 'ios-film';
                    }
                    else if (['mp3','wav','wma','ogg','aac','flac'].indexOf(format) > -1) {
                        type = 'ios-musical-notes';
                    }
                    else if (['doc','docx'].indexOf(format) > -1) {
                        type = 'md-document';
                    }
                    else if (['pdf'].indexOf(format) > -1) {
                        type = 'ios-document';
                    }
                    else if (['numbers','csv','xls','xlsx'].indexOf(format) > -1) {
                        type = 'ios-stats';
                    }
                    else if (['keynote','ppt','pptx'].indexOf(format) > -1) {
                        type = 'ios-videocam';
                    }
                    else {
                        type = 'ios-document-outline';
                    }
                }
                return type;
            },
            /**
             * 删除附件
             * @param id
             */
            deleteUploadFile(id){
                deleteFileById(id).then(res => {
                    this.$Message.info("移除附件成功");
                    this.fileList = this.fileList.filter(item => {
                        return item.id !== id;
                    })
                    this.$emit('update:fileList', this.fileList);
                    //console.log(this.fileList);
                })
            },
            /**
             * 预览附件
             * @param file
             */
            handleView(file){
                //;
                if(this.uploadType === "video"){
                    this.$Modal.info({
                        title: '视频播放',
                        width: "60%",
                        render: (h) => {
                            return h("video-player",{
                               props:{
                                   options:{
                                       playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                                       autoplay: false, //如果true,浏览器准备好时开始回放。
                                       muted: false, // 默认情况下将会消除任何音频。
                                       loop: false, // 导致视频一结束就重新开始。
                                       preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                                       language: 'zh-CN',
                                       aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                                       fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                                       sources: [{
                                           type: "video/mp4",
                                           // mp4
                                           src: file.originalUrl,

                                       }],
                                       poster: "",
                                       notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                                       controlBar: {
                                           timeDivider: true,
                                           durationDisplay: true,
                                           remainingTimeDisplay: false,
                                           fullscreenToggle: true  //全屏按钮
                                       }
                                   },

                                }

                            })
                        }
                    })
                }else{
                    this.$Modal.info({
                        title: '图片预览',
                        width: "60%",
                        render: (h) => {
                            return h('img', {
                                style: {
                                    width: "100%",
                                },
                                attrs: {
                                    src: file.originalUrl
                                }
                            })
                        }
                    })
                }
            }
        },
        mounted(){

        },
        watch:{
            businessId(val){
                this.options.query.businessId = val;
            },
            tempId(val){
                this.options.query.tempId = val;
            },
            basedictStorage(val){
                this.options.query.basedictStorage = val;
            }
        }
    }
</script>

<style scoped lang="scss">
    .multify-uploader-wraper{
        padding:5px;
        position:relative;
        min-height:300px;
    }
    #global-uploader {
        position: absolute;
        z-index: 20;
        right: 15px;
        bottom: 15px;

        .uploader-app {
            width: 520px;
        }

        .file-panel {
            background-color: #fff;
            border: 1px solid #e2e2e2;
            border-radius: 7px 7px 0 0;
            box-shadow: 0 0 10px rgba(0, 0, 0, .2);

            .file-title {
                display: flex;
                height: 30px;
                line-height: 30px;
                padding: 0 15px;
                border-bottom: 1px solid #ddd;

                .operate {
                    flex: 1;
                    text-align: right;
                }
            }

            .file-list {
                position: relative;
                height: 150px;
                overflow-x: hidden;
                overflow-y: auto;
                background-color: #fff;

                > li {
                    background-color: #fff;
                    /deep/ .uploader-file{
                        height: 30px;
                        line-height: 30px;
                    }
                }
            }

            &.collapse {
                .file-title {
                    background-color: #E7ECF2;

                }
            }
        }

        .no-file {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 14px;
        }

        /deep/.uploader-file-icon {
            &:before {
                content: '' !important;
            }

            &[icon=image] {
                background: url(../image/image-icon.png);
                margin-top: 2px;
            }
            &[icon=video] {
                background: url(../image/video-icon.png);
                margin-top: 2px;
            }
            &[icon=document] {
                background: url(../image/text-icon.png);
                margin-top: 2px;
            }
        }

        /deep/.uploader-file-actions > span {
            margin-right: 6px;
            margin-top:5px;
        }
    }

    /* 隐藏上传按钮 */
    #global-uploader-btn {
        position: absolute;
        clip: rect(0, 0, 0, 0);
    }
    /*附件样式*/
    .file-wrapper{
        display:flex;
        flex-direction:row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: flex-start;
        min-height:300px;
        background:#fff;

        .paas-upload-list{
            height:160px;
            text-align: center;
            border:1px #d9d9d9 solid;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            border-radius: 4px;
            background: #FFFFFF;
            position:relative;
            box-shadow: 0 1px 1px rgba(0,0,0,.2);
            margin-right:4px;
            margin-top:10px;
            min-width:160px;
            vertical-align: middle;


            &:hover{
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
                transform: translate3d(0, -2px, 0);
                .paas-upload-list-cover{
                    display:block;
                }
            }

            .paas-upload-show-file {
                height:130px;
                img,
                video,
                audio{
                    height:130px;
                    padding:5px;
                }
            }
            .file-name{
                height: 30px;
                color: black;
                width:100%;
                bottom:0;
            }
            .paas-upload-list-cover{
                display:none;
                position:absolute;
                top:0;
                bottom: 0;
                left:0;
                right:0;
                background: rgba(0,0,0,.6);
                i{
                    color:#FFFFFF;
                    font-size: 40px;
                    cursor: pointer;
                    margin:50px 2px;
                }
            }


        }
    }
    // 调整播放器样式
    .video-js .vjs-icon-placeholder {
        width: 100%;
        height: 100%;
        display: block;
    }

</style>

